import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './lib/attribution'
import App from './App.tsx'

// -- Umami: dev ID in development, production ID when deployed (build)
const umamiWebsiteId =
  import.meta.env.MODE !== 'development'
  ? (import.meta.env.VITE_UMAMI_WEBSITE_ID ?? '79495a82-9840-463d-8753-d77cad912b4d') // www.drivible.com in Umami
    : (import.meta.env.VITE_UMAMI_WEBSITE_ID_DEV ?? '09643f46-44f7-4577-a551-ae2ee8c4e29b') // marketing.drivible.com in Umami
const umami = document.createElement('script')
umami.defer = true
umami.src = 'https://umami.tracking.drivible.com.au/script.js'
umami.setAttribute('data-website-id', umamiWebsiteId)
document.head.appendChild(umami)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
